import script from "./PiramidMethodView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PiramidMethodView.vue?vue&type=script&setup=true&lang=ts"

import "./PiramidMethodView.vue?vue&type=style&index=0&id=035dea2c&lang=css"

const __exports__ = script;

export default __exports__